import _ from 'lodash';
import { Meeting, MeetingAccountSource, MeetingCertifierSource } from '../../../objects/Meeting';
import { createValidFilename, getFilenameAndExtension } from '../../../react/components/FileManager/model/fileValidation';

/**
 * @typedef { import('../../../objects/Attachment').AttachmentInfo } AttachmentInfo
 * @typedef { import('../../../objects/Ceremony').CeremonyDetails } CeremonyDetails
 */

/**
 * @param {CopyAttachmentModel} a 
 * @param {CopyAttachmentModel} b 
 */
export function compareByTitle(a, b) {
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;

    if (a.filename) {
        if (b.filename) {
            let res = a.filename.localeCompare(b.filename, 'sv', { numeric: true });
            if (res != 0) {
                return res;
            }
        } else {
            return -1;
        }
    } else if (b.filename) {
        return 1;
    }

     return (a.timestamp?.getTime() || 0) - (b.timestamp?.getTime() || 0);
}

export class CopyAttachmentModel {
    /**
     * @param {AttachmentInfo} source
     */
    constructor(source) {
        this.attachment = source;
        this.key = source.Id;
        this.filename = source.Filename;
        this.timestamp = source.CreatedTimestamp;
        this.isSelected = false;
        this.validName = createValidFilename(source.Filename);
        this.renameTo = this.validName !== this.filename ? this.validName : null;
    }

    createCopy() {
        return {
            SourceId: this.attachment.Id,
            Rename: this.renameTo,
        };
    }
}

function convertToMeeting(ceremony) {
    var meeting = new Meeting();
    meeting.Organization = ceremony.Mission.MandatePeriod.Organization;
    meeting.WageCalculation = meeting.Organization?.WageCalculation;
    meeting.Designation = ceremony.Designation;
    meeting.Location = ceremony.Location;
    meeting.MeetingTime = ceremony.CeremonyTime;
    meeting.Date = ceremony.CeremonyDate;
    meeting.MeetingType = 1;
    meeting.AccountSource = MeetingAccountSource.missionOrganization;
    meeting.CertifierSource = MeetingCertifierSource.missionOrganization;
    return meeting;
}

export class ConvertCeremonyModel {
    /**
     * @param {CeremonyDetails} ceremony
     */
    constructor(ceremony) {
        this.meeting = convertToMeeting(ceremony);
        this.attachments = _.map(ceremony.Attachments, x => new CopyAttachmentModel(x));
        this.attachments.sort(compareByTitle);
    }

    calculateRenames() {
        const grouped = _.groupBy(this.attachments, x => x.validName.toLowerCase());
        _.forEach(grouped, group => {
            let selectedIndex = 0;
            for (let att of group) {
                if (att.isSelected && selectedIndex++ > 0) {
                    const nameParts = getFilenameAndExtension(att.validName);
                    att.renameTo = `${nameParts.filename} (${selectedIndex-1})${nameParts.extension}`;
                } else if (att.validName !== att.filename) {
                    att.renameTo = att.validName;
                } else {
                    att.renameTo = null;
                }
            }
        });
    }

    createAdd() {
        let result = {};
        result.Meeting = this.meeting;
        result.CopyAttachments = _.chain(this.attachments).filter(x => x.isSelected).map(x => x.createCopy()).value();
        return result;
    }
}
